import {Injectable} from '@angular/core';
import {isRight} from 'fp-ts/lib/Either';
import {Type} from 'io-ts';

@Injectable({
	providedIn: 'root'
})
export class TypeCheckService {
	constructor() {}

	validate<T>(input: unknown, model: Type<T>) {
		return isRight(model.decode(input));
	}

	printTypeCheck<T>(input: unknown, model: Type<T>) {
		const result = model.decode(input);
		return isRight(result) ? result.right : this.throwError<T>(result, model);
	}

	throwError<T>(_input: unknown, _model: Type<T>): void {
	}
}
